import router, { getHistoryDepth, getRouteParent } from '$navigation/router';
import { FEED } from '$shared/constants/pages';
import { addListMemberActions } from '$store/addListMember';
import { store } from '$store/store';

export function showModal(name, isReplace = false, params = {}, options = {}) {
  const route = router.getState();

  router.navigate(
    route.name,
    {
      ...route.params,
      ...params,
      w: name,
    },
    {
      click: true,
      replace: isReplace,
      ...options,
    },
  );
}

export function goTo(name, params = {}, options = {}) {
  router.navigate(name, params, options);
}

export function isModalShown() {
  const route = router.getState();
  return !!route.params.w;
}

export function hideModal() {
  // Вероятнее всего тебе стоит использовать goBack() что бы не сломать навигацию
  // Эта фкнция имеет смысл в таких местах, как закрытие просмоторщика после нескольких переходов

  const route = router.getState();
  if (route.params.w) {
    const params = { ...route.params };
    delete params.w;
    router.navigate(route.name, params, { replace: true });
  }
}

export const goBack = (ignoreHistory = false, delta = 1) => {
  const route = router.getState();
  const { name, params } = route;
  // a modal opened by a direct link has nothing to go back to: drop it in place
  if (route.params.w && getHistoryDepth() < delta) {
    hideModal();
  } else if (hasHistoryBack() && !ignoreHistory) {
    window.history.go(-delta);
  } else {
    const routeParams: { [key: string]: string } = {};
    const currentState = router.getState();

    if (currentState.params.authorId) {
      routeParams.domain = 'id' + currentState.params.authorId;
    }

    if (currentState.params.domain) {
      routeParams.domain = currentState.params.domain;
    }

    const route = getRouteParent(name);
    if (route) {
      router.navigate(route, routeParams, {
        replace: !ignoreHistory,
        transition: false,
      });
    } else if (params && params.w) {
      router.navigate(name, routeParams, {
        replace: !ignoreHistory,
        transition: false,
      });
    } else {
      router.navigate(
        FEED,
        {},
        {
          replace: !ignoreHistory,
          transition: false,
        },
      );
    }
  }
};

export const hasHistoryBack = (): boolean => getHistoryDepth() > 0;

export const getPreviousRoute = (): string | null => {
  return history.state?.meta?.options?.previousRoute || null;
};

export const wasReturnedBack = (): boolean => {
  return history.state?.meta?.source === 'popstate';
};
